import React from 'react';
import {
  Box,
  Card,
  CardHeader,
  CardContent,
  Avatar,
  IconButton,
  Skeleton
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

const CardSkeleton = ({ count = 1 }) => {
  return (
    <Box sx={{ m: '10px',display: "flex",gap: 2 }}>
      {[...Array(count)].map((_, index) => (
            <Card key={index} sx={{ width: 345 }}>
              <CardHeader
                avatar={
                  <Skeleton variant="circular">
                    <Avatar />
                  </Skeleton>
                }
                action={
                  <IconButton aria-label="settings">
                    <MoreVertIcon />
                  </IconButton>
                }
                title={<Skeleton width="60%" />}
                subheader={<Skeleton width="80%" />}
              />
              <CardContent sx={{ pt: '0' }}>
                {[...Array(4)].map((_, idx) => (
                  <Box key={idx} sx={{ display: 'flex', width: '100%', mb: '8px' }}>
                    <Box sx={{ width: '49%' }}>
                      <Skeleton width="80%" height={20} />
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      {idx % 2 === 0 ? (
                        <CurrencyRupeeIcon
                          sx={{
                            color: '#DAA520',
                            filter: 'drop-shadow(0 0 4px rgba(218, 165, 32, 0.7))',
                          }}
                        />
                      ) : (
                        <CalendarMonthIcon sx={{ color: 'primary.main' }} />
                      )}
                      <Skeleton width={80} height={20} />
                    </Box>
                  </Box>
                ))}
              </CardContent>
            </Card>
      ))}
    </Box>
  );
};

export default CardSkeleton;
